import FaqCategory from 'models/FaqCategory';

import Component from './component';

export interface Props {
    categories: FaqCategory[];
    activeCategorySlug?: string;
}

Component.defaultProps = {
    activeCategorySlug: null,
};
export default Component;